var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('p',{staticClass:"error-message"},[_vm._v(_vm._s(this.$t("pages.wording."+this.desc )))])])
}
var staticRenderFns = []

export { render, staticRenderFns }